<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <a-form >
      <a-form-item
        label="用户头像"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">
          <avatar-edit :src="user_avatar" />
        </span>
      </a-form-item>

      <a-form-item
        label="用户名"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_name}` }}</span>
      </a-form-item>

      <a-form-item
        label="用户昵称"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_nickname}` }}</span>
      </a-form-item>

      <a-form-item
        label="手机"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_mobile}` }}</span>
      </a-form-item>

      <a-form-item
        label="QQ"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_qq}` }}</span>
      </a-form-item>

      <a-form-item
        label="邮箱"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_mail}` }}</span>
      </a-form-item>

      <a-form-item
        label="备注信息"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${user_comments}` }}</span>
      </a-form-item>

      <a-form-item
        label="创建时间"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }"
      >
        <span style="padding-left:10px">{{ `${created_at}` }}</span>
      </a-form-item>

      <a-form-item :wrapperCol="{ span: 22 }" style="text-align: center">
        <a-button htmlType="submit" type="primary" @click="handleEdit()">编辑</a-button>
      </a-form-item>
    </a-form>
    <edit-user-info-modal ref="user" @userInfoChanged="reloadData"/>
  </a-card>
</template>

<script>

import EditUserInfoModal from './modules/EditUserInfoModal'
import AvatarEdit from '@/components/AvatarEdit'
 

export default {
  name: 'UserInfo',
  components: {
    EditUserInfoModal,
    AvatarEdit
  },
  data () {
    return {
      user_avatar: '',
      user_name: '',
      user_nickname: '',
      user_mobile: '',
      user_qq: '',
      user_comments: '',
      created_at: '',
      user_mail: ''
    }
  },
  created () {
    this.loadData()
  },

  methods: {
    loadData(){
      const user = this.$store.getters.userInfo
      this.user_avatar = user.user_avatar
      this.user_name = user.user_name
      this.user_nickname = user.user_nickname == null ? '' : user.user_nickname 
      this.user_mobile = user.user_mobile == null ? '' : user.user_mobile
      this.user_qq = user.user_qq == null ? '' : user.user_qq
      this.user_comments = user.user_comments == null ? '' : user.user_comments
      this.created_at = user.created_at == null ? '' : user.created_at
      this.user_mail = user.user_mail == null ? '' : user.user_mail
    },
    handleEdit () {
      this.$refs.user.edit()
    },
    reloadData(){
      const _this = this
      this.$store.dispatch('GetUserInfo').then(res=>{
        _this.loadData()
      })
    }
  }
}
</script>
